import AuditLog from "../components/AuditLog/AuditLogList";

export default function AuditLogView() {
    return <AuditLog />;
}
